// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__31bbk","requiredAsterisk":"Info_requiredAsterisk__2gnon"};